// eslint-disable-next-line @typescript-eslint/no-explicit-any -- type is unknown
export const localeFilesMap: Record<string, Promise<any>> = {
  'en-BE': import('./i18n/en-BE.json'),
  'en-NL': import('./i18n/en-NL.json'),
  'fr-BE': import('./i18n/fr-BE.json'),
  'nl-BE': import('./i18n/nl-BE.json'),
  'nl-NL': import('./i18n/nl-NL.json'),
}
